<template>
    <section id="service_content">

        <div class="container pt-4">

            <h3 class="text-center">الخدمات</h3>

            <div class="d-flex justify-content-center align-items-center">
                <p class="text-center">نوفر في ذكاء القابضة كافة الخدمات بشكل احترافي وحديث حتى نواكب الثورة الصناعية
                    الرابعة
                    والتقنيات الحديثة لتمكين النشئ من مهارات القرن الحادي والعشرين</p>
            </div>

            <!-- In Large Screen -->

            <div class="row g-3 mt-3 d-none d-lg-flex">

                <div class="col-lg-3">
                    <router-link :to="{ name: 'marketing' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/marketing.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">التسويق والفعاليات</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'cloud_technologies' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/cloud_technologies.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">التقنيات السحابية والذكاء الإصطناعي</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'training' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/training.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">التعليم والتدريب</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'sports' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/sports.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">الرياضة والمنافسات التعليمية</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'consulting' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/consulting.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">الاستشارات</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'research' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/research.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">البحث والتطوير</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'robotics_industry' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/robotics_industry.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">صناعة الإلكترونيات والروبوتات</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-lg-3">
                    <router-link :to="{ name: 'business_incubators' }">
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/services/business_incubators.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">حاضنات الأعمال</h5>
                            </div>
                        </div>
                    </router-link>
                </div>

            </div>

            <!-- In Small Screen -->

            <div id="content_wrapper_mobile" class="d-flex justify-content-center d-lg-none mt-3">

                <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">

                    <div class="carousel-inner">

                        <div class="carousel-item active">
                            <router-link :to="{ name: 'marketing' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/marketing.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">التسويق والفعاليات</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'cloud_technologies' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/cloud_technologies.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">التقنيات السحابية والذكاء الإصطناعي</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'training' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/training.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">التعليم والتدريب</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'sports' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/sports.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">الرياضة والمنافسات التعليمية</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'consulting' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/consulting.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">الاستشارات</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'research' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/research.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">البحث والتطوير</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'robotics_industry' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/robotics_industry.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">صناعة الإلكترونيات والروبوتات</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                        <div class="carousel-item">
                            <router-link :to="{ name: 'business_incubators' }">
                                <div class="card p-3">
                                    <div class="image_wrapper">
                                        <img class="card-img-top" src="@/assets/images/services/business_incubators.webp" alt="" />
                                    </div>
                                    <div class="card-body">
                                        <h5 class="card-title text-center">حاضنات الأعمال</h5>
                                    </div>
                                </div>
                            </router-link>
                        </div>

                    </div>

                    <!-- https://www.youtube.com/watch?v=BrCz-FlPGgk -->

                    <!-- Carousel controls -->

                    <div class="d-flex justify-content-center">

                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleSlidesOnly"
                            data-bs-slide="next">
                            <font-awesome-icon :icon="['fas', 'fa-arrow-right']" />
                        </button>

                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleSlidesOnly"
                            data-bs-slide="prev">
                            <font-awesome-icon :icon="['fas', 'fa-arrow-left']" />
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Service',
}
</script>

<style lang="scss" scoped>
#service_content {

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        p {
            color: $White;
            font-size: 18px;
            line-height: 180%;
            width: 794px;

            @include breakpoints(x-small) {
                font-size: 16px;
                // width: 343px;
            }

            @include breakpoints(small) {
                font-size: 16px;
            }

            @include breakpoints(medium) {
                font-size: 16px;
            }

            @include breakpoints(large) {
                font-size: 16px;
            }
        }

        .card {

            background: $Dark-Green;

            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
            clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

            height: 190px;

            .image_wrapper {
                width: 50%;
                height: 80px;
                margin: auto;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }

            .card-body {

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $White;
                }

            }


        }

        .card:hover {
            background: $Linear-Blue;
        }

        // In Small Screen

        #content_wrapper_mobile {

            .carousel {

                @include breakpoints(x-small) {
                    width: 80%;
                }

                @include breakpoints(small) {
                    width: 80%;
                }

                @include breakpoints(medium) {
                    width: 80%;
                }

                .carousel-inner {

                    .carousel-item {

                        .card {

                            margin-left: 8px;
                            margin-right: 8px;

                        }

                    }

                }

                .carousel-control-prev,
                .carousel-control-next {
                    position: static;
                    padding-top: 24px;

                }

                .carousel-control-prev svg,
                .carousel-control-next svg {
                    color: $Green;
                    font-size: 24px;
                }


            }
        }

    }

}
</style>